import React, {useEffect, useState} from "react";
import GameTrack from "@/Core/GameTrack";
import {useAppDispatch} from "@/app/storeHooks";
import {RewardType, SET_REWARD_TYPE} from "@/app/userSlice";
import styles from "./GuidePage.module.css";

export interface GuidePageStepProps {
    content?: React.ReactNode;
}

export type GuidePageProps = {
    open?: boolean;
    steps: GuidePageStepProps[];
    onClose?: () => void;
    onGuideEnd?: () => void;
}

const GuidePage: React.FC<GuidePageProps> = props => {
    const {
        open = false,
        steps = [],
        onClose,
        onGuideEnd,
    } = props;

    const dispatch = useAppDispatch();

    const [currentStep, setCurrentStep] = useState<number>(0);
    const onClickNext = () => {
        switch (currentStep) {
            case 0:
                GameTrack.click_guide_gc();
                dispatch(SET_REWARD_TYPE(RewardType.SC));
                break;
            case 1:
                GameTrack.click_guide_sc();
                break;
            case 2:
                GameTrack.click_guide_redeem();
                break;
            case 3:
                GameTrack.click_guide_reward();
                break;
            case 4:
                GameTrack.click_guide_account();
                break;
        }
        setCurrentStep(currentStep + 1);
    }
    useEffect(() => {
        if (open) {
            if ((currentStep + 1 > steps.length)) {
                onGuideEnd && onGuideEnd()
            }
        }
    }, [open, steps, currentStep]);

    return (
        <>
            {open && steps && (
                <div className={styles.guide_page} onClick={onClickNext}>
                    {steps && steps.map((step, index) => {
                        return React.cloneElement(step.content as React.ReactElement, {
                            key: index,
                            currentStep,
                            currIndex: index,
                            onClick: onClickNext,
                            // onNext,
                            // onClose: handleClose,
                        })
                    })}
                </div>
            )}
        </>
    )
}

export default GuidePage;